import { render, staticRenderFns } from "./EnterTotp.vue?vue&type=template&id=010a8389"
import script from "./EnterTotp.vue?vue&type=script&lang=ts"
export * from "./EnterTotp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010a8389')) {
      api.createRecord('010a8389', component.options)
    } else {
      api.reload('010a8389', component.options)
    }
    module.hot.accept("./EnterTotp.vue?vue&type=template&id=010a8389", function () {
      api.rerender('010a8389', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/EnterTotp.vue"
export default component.exports